import React from 'react';

import AnimatedCloseButtonComponent from '../animatedCloseButtonComponent/animatedCloseButtonComponent';

import './videoPlayerComponentV2.css';

const VideoPlayerComponentV2 = ({
  isMinified = true,
  autoPlay = true,
  loop = true,
  muted = true,
  videoSrcUrl = null,
  onClose = () => {},
}) => {
  return (
    videoSrcUrl && (
      <>
        {isMinified ? (
          <div className="et-v2-video-player-minified-container">
            <video
              key={videoSrcUrl}
              className="et-v2-vpc-video-wrap"
              autoPlay={autoPlay}
              loop={loop}
              muted={muted}
              poster={videoSrcUrl}>
              <source src={videoSrcUrl} type="video/webm" />
            </video>
          </div>
        ) : (
          <div className="et-v2-video-player-enlarged-container">
            <AnimatedCloseButtonComponent onClick={onClose} />
            <video
              key={videoSrcUrl}
              className="et-v2-vpc-video-wrap"
              autoPlay={autoPlay}
              loop={loop}
              muted={muted}
              poster={videoSrcUrl}>
              <source src={videoSrcUrl} type="video/webm" />
            </video>
          </div>
        )}
      </>
    )
  );
};

export default VideoPlayerComponentV2;
